import { render } from "./Login-signup.vue?vue&type=template&id=5c709ea9&lang=pug"
import script from "./Login-signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Login-signup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__